export default __webpack_public_path__ + "static/media/icon_user.ec3361cf.svg";